import * as React from "react";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
    checked?: boolean;
}

const CheckIcon = ({ checked }: Props) =>
    (checked !== null && checked !== undefined)
        ? (checked
            ? <FontAwesomeIcon style={{ color: "green" }} icon={faCheck} />
            : <FontAwesomeIcon style={{ color: "red" }} icon={faTimes} />)
        : null;

export default CheckIcon;